import { render, staticRenderFns } from "./CustomerRegistration.vue?vue&type=template&id=3aee8330&scoped=true&"
import script from "./CustomerRegistration.vue?vue&type=script&lang=ts&"
export * from "./CustomerRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerRegistration.vue?vue&type=style&index=0&id=3aee8330&lang=scss&scoped=true&"
import style1 from "./CustomerRegistration.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aee8330",
  null
  
)

export default component.exports